<template>
    <div class="text-center margin-top">
        <button
            :disabled="disabled || loading"
            class="btn btn-sm mx-auto btn-primary btn-responsive"
            type="submit"
        >
            <i class="fa fa-spinner fa-spin" v-if="loading"></i> {{ text }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'SubmitButton',

    props: {
        disabled: {
            default: false,
            required: false,
            type: Boolean,
        },
        loading: {
            default: false,
            required: false,
            type: Boolean,
        },
        text: {
            required: true,
            type: String,
        },
    },
}
</script>

<style lang="scss">
.btn-responsive {
    display: block;
    width: 50%;
    margin: 0 auto;
}

@media (min-width: 960px) {
    .btn-responsive {
        width: 50%;
    }
}

@media (min-width: 768px) and (max-width: 959px) {
    .btn-responsive {
        width: 70%;
    }
}

@media (max-width: 767px) {
    .btn-responsive {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrSignup/SubmitButton.vue